import React from 'react';
import logoSrc from '../../assets/Logo/mindmap.png';

const Logo = ({ className, style, alt = 'MileDocs Logo' }) => (
  <img src={logoSrc} alt={alt} className={className} style={style} />
);

export default Logo;
